/**
 * Badge del rol de un usuario (presentacional).
 *
 * Color por rol del sistema (paridad con el SSR: admin rojo, supervisor ámbar,
 * etc.); los roles personalizados/desconocidos usan el color por defecto. Muestra
 * el nombre del rol si se le pasa (`label`), o el id en su defecto.
 */
import { cn } from "@/components/ui";

import { ROLE_BADGE_CLASS, ROLE_BADGE_DEFAULT_CLASS } from "../constants";

interface RoleBadgeProps {
  role: string;
  label?: string;
}

export function RoleBadge({ role, label }: RoleBadgeProps) {
  const className = ROLE_BADGE_CLASS[role] ?? ROLE_BADGE_DEFAULT_CLASS;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        className,
      )}
    >
      {label ?? role}
    </span>
  );
}
